export default __webpack_public_path__ + "static/media/09.50247579.jpg";